"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAvg = function getAvg(values, total) {
  return values.reduce(function (sum, value) {
    return sum + value;
  }, 0) / (total || values.length);
};

exports.default = getAvg;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/getAvg.js
// module id = 452
// module chunks = 0